/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusErlassAufgabenResponseDto } from '../../models/lexplus-erlass-aufgaben-response-dto';

export interface ErlassDetailControllerGetErlassAufgabenV1$Params {
  erlassID: number;
  erledigtLimit?: number;
}

export function erlassDetailControllerGetErlassAufgabenV1(http: HttpClient, rootUrl: string, params: ErlassDetailControllerGetErlassAufgabenV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusErlassAufgabenResponseDto>> {
  const rb = new RequestBuilder(rootUrl, erlassDetailControllerGetErlassAufgabenV1.PATH, 'get');
  if (params) {
    rb.path('erlassID', params.erlassID, {});
    rb.query('erledigtLimit', params.erledigtLimit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusErlassAufgabenResponseDto>;
    })
  );
}

erlassDetailControllerGetErlassAufgabenV1.PATH = '/v1/compliance/erlasse/{erlassID}/aufgaben';
